import React, { useEffect, useState } from "react";
import { useStores } from "@/store";
import { useObserver } from "mobx-react-lite";
import { Affix } from "antd";

/**右侧栏 */
export const Aside = () => {
  const { dealStore } = useStores();
  const [headBarHeight, setHeadBarHeight] = useState(0);
  useEffect(() => {
    const getHeadBarElement = () => document.querySelector(".ui-head-bar");

    let rafId = null;
    const measure = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const headBarElement = getHeadBarElement();
        if (!headBarElement) {
          setHeadBarHeight(30);
          return;
        }
        const next =
          Math.ceil(headBarElement.getBoundingClientRect().height) + 20;
        setHeadBarHeight((prev) => (prev === next ? prev : next));
      });
    };

    measure();

    const headBarElement = getHeadBarElement();
    const resizeObserver =
      headBarElement && typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(measure)
        : null;

    if (resizeObserver && headBarElement)
      resizeObserver.observe(headBarElement);
    window.addEventListener("resize", measure, { passive: true });

    return () => {
      window.removeEventListener("resize", measure);
      if (resizeObserver) resizeObserver.disconnect();
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);
  useEffect(() => {
    window.iframeResize.create("#web_form");
  }, []);
  return useObserver(() => {
    return (
      <aside className="page-deal--aside">
        <Affix offsetTop={headBarHeight}>
          <iframe
            id="web_form"
            key={dealStore.webform}
            src={dealStore.webform}
            frameBorder="0"
          ></iframe>
        </Affix>
      </aside>
    );
  });
};
